<template lang="jade" src="../_partials/input.jade"></template>
<script>
  import _ from 'lodash'
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: '',
        type: 'email'
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce: val => val.editable ? val : _.set(val, 'field', false)
      },
      paste: {
        type: Boolean,
        default: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// email.vue?7e9be2f8